const Config = {
  Domain: 'ems-p2p.ageasfederal.com/tms',
  Protocol: 'https',
  ListLimit: 20,
  P2PDomain: 'ems-p2p.ageasfederal.com/TnEV1_0AWeb/',
  P2PProtocol: 'https',
  RentDomain: 'ems-p2p.ageasfederal.com/TnEV1_0AWeb/',
  RentProtocol: 'https',
  getUrl: function() {
    return Config.Protocol + '://' + Config.Domain
  },

  getP2PUrl: function() {
    return Config.P2PProtocol + '://' + Config.P2PDomain
  },
  getRentUrl: function() {
    return Config.RentProtocol + '://' + Config.RentDomain
  }
}

export default Config
